import React from 'react'
import {calendlyLink} from "./calendlyLink";

export const scheduleCallText = (text) => (<a href={calendlyLink} target="_blank" rel="noopener noreferrer">{text}</a>)